import { ReactElement } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { COLORS } from '../../../config/colors';
import { THEME_COLORS } from '../../../theme/constants/themeColors';
import { THEME_STYLES } from '../../../theme/constants/themeStyles';

type Props = {
  headingComponent: ReactElement;
  lineItems: Array<{
    shouldShow?: boolean;
    leftComponent: ReactElement;
    rightComponent: ReactElement;
  }>;
  style?: ViewStyle;
};

export const GroupedLineItemsCard = (props: Props) => {
  const { headingComponent, lineItems, style = {} } = props;

  return (
    <View style={[styles.whiteBox, style]}>
      <View
        style={{
          justifyContent: 'space-between',
          flexDirection: 'row'
        }}>
        <>{headingComponent}</>
      </View>

      <View style={styles.divider} />

      {lineItems.map((lineItem, index) => {
        const { leftComponent, rightComponent, shouldShow = true } = lineItem;

        if (!shouldShow) return null;

        return (
          <View key={index} style={[styles.rowStyle, { marginTop: 8 }]}>
            <View
              style={{
                flex: 0.8
              }}>
              {leftComponent}
            </View>
            <View>{rightComponent}</View>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  rowStyle: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  whiteBox: {
    backgroundColor: THEME_COLORS.bgSecondary,
    borderWidth: 1,
    // borderBottomWidth: 3,
    // borderColor: COLORS.primaryLight,
    ...THEME_STYLES.themeBorder,
    ...THEME_STYLES.item,
    borderRadius: 16,
    padding: 16,
    paddingBottom: 12,
  },
  divider: {
    height: 1,
    backgroundColor: THEME_COLORS.neutralBorderColor,
    marginTop: 12,
    marginBottom: 6,
    borderRadius: 8
  }
});

export default GroupedLineItemsCard;
